import { render, staticRenderFns } from "./AppSelector.vue?vue&type=template&id=b8ec46d6&scoped=true"
import script from "./AppSelector.vue?vue&type=script&lang=js"
export * from "./AppSelector.vue?vue&type=script&lang=js"
import style0 from "./AppSelector.vue?vue&type=style&index=0&id=b8ec46d6&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ec46d6",
  null
  
)

export default component.exports